// extracted by mini-css-extract-plugin
export default {"container":"vN-z","topReviewHeading":"wN-z","criticalReview":"xN-z","favorableReview":"yN-z","vsSeparator":"zN-z"};